module.exports = __webpack_public_path__ + "img/Logo_DMB-RS_Claim.23558504.svg";